import React from 'react'

function Menu() {
  return (
    <div className='menu'>
        <ul>
            <li><a href="#">About</a></li>
            <li><a href="#experience">Skills</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contacts">Contact</a></li>
        </ul>
    </div>
  )
}

export default Menu